import { styled } from '@acko-tech/building-blocks.ui.common';

export const HeaderWrapper = styled.div`
    background-color: #5e27c9;
`;

export const Container = styled.div`
    max-width: 1440px;
    margin: auto;
    padding: 0 120px;

    @media only screen and (max-width: 780px) {
        padding: 0 20px;
    }
`;

export const RequestDemoButton = styled.div`
    display: flex;
    width: 189px;
    padding: 16px 32px;
    background: #37c87e;
    border-radius: 8px;
    color: #ffffff;
    margin-top: 42px;
    justify-content: center;
    cursor: pointer;
    width: 250px;
`;

export const LogoWrapper = styled.div`
    margin-top: 20px;
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;

    @media only screen and (max-width: 1320px) {
        justify-content: center;
        text-align: center;
    }
`;

export const TextWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;

    @media only screen and (max-width: 1320px) {
        order: 2;
        align-items: center;
        margin: 20px 0 40px 0;
    }
`;

export const TitleText = styled.div`
    font-family: Inter;
    font-style: normal;
    font-weight: bold;
    font-size: 42px;
    line-height: 52px;
    letter-spacing: -0.4px;
    color: #ffffff;
    max-width: 500px;

    @media only screen and (max-width: 780px) {
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        letter-spacing: unset;
        max-width: 600px;
        margin: 0 40px;
    }
`;

export const BannerWrapper = styled.div`
    padding-right: 40px;
`;
